import React from 'react';
import { fromJS, Map } from 'immutable';
import { createFilterIndex, timesOfDay, timeOfDayPredicate } from './timeOfDay';
import { withStateHandlers } from 'recompose';
import classnames from 'classnames';
import numeral from 'numeral';

/** UI for a 'time of day' filter which divides the
 * day into time buckets (Morning, Afternoon, Night)
 * per "from" route.
 *
 * @author Dawid Loubser
 */

const TimeOfDayFilter = ({ offers, requested, todFilters, todTab, toggleTodFilter, todTabSwitcher }) => {
  const filterIndex = createFilterIndex(offers, requested);
  return (
    <div>
      <h4>Schedule</h4>

      <ul className='nav nav-pills two-pills'>
        <li onClick={todTabSwitcher} className={classnames({ active: todTab === 'Departure' })}>
          <a style={{cursor:"pointer"}}>Departure</a>
        </li>
        <li onClick={todTabSwitcher} className={classnames({ active: todTab === 'Arrival' })}>
          <a style={{cursor:"pointer"}}>Arrival</a>
        </li>
      </ul>

      {filterIndex
        .map((tods, routeKey) => (
          <div
            className='route'
            style={{
              display:
                (todTab === 'Departure' && routeKey.indexOf('From') > -1) || (todTab === 'Arrival' && routeKey.indexOf('To') > -1) ? 'block' : 'none',
            }}
            key={routeKey}
          >
            <h5>{routeKey}</h5>
            <div className='buttons'>
              {timesOfDay.map((todName) => {
                const todData = tods.get(todName);
                const keyPath = [routeKey, todName];
                return (
                  <TodButton
                    key={keyPath}
                    onClick={todData ? toggleTodFilter.bind(null, keyPath) : undefined}
                    tod={todName}
                    active={todFilters.getIn(keyPath)}
                    todData={todData}
                  />
                );
              })}
            </div>
          </div>
        ))
        .valueSeq()}
    </div>
  );
};

/** Individual 'time of day' bucket button. */
const TodButton = ({ tod, todData, active, onClick }) => (
  <div
    className={classnames({
      todButton: true,
      disabled: todData == null,
      selectable: todData != null,
      active,
    })}
    onClick={onClick}
  >
    <div className='todName'>{tod}</div>
    {todData && <div className='price cheapest'>{numeral(todData.get('lowest', 0)).format('0,0')}</div>}
  </div>
);

export default withStateHandlers(
  // Initial state
  {
    // Sparse Tree structure that tracks which toggle
    // button filters are active
    todFilters: fromJS({
      /*route : {
                tod : {}
            }*/
    }),
    todTab: 'Departure',
  },
  // Handlers
  {
    toggleTodFilter: ({ todFilters = Map(), ...state }, { onFilter }) =>
      // Toggles a particular route-and-time bucket to be
      // active or not

      (keyPath) => {
        // Maintain sparse map (no keys with empty values)
        // This is key to the implementation / algorithm
        const newFilters = todFilters.withMutations((t) => {
          if (t.hasIn(keyPath)) {
            t.deleteIn(keyPath);
          } else {
            t.setIn(keyPath, true);
          }
          if (t.get(keyPath[0], Map()).isEmpty()) {
            t.delete(keyPath[0]);
          }
        });

        // Provide updated predicate (filter fn) to parent
        if (onFilter) {
          onFilter(newFilters.isEmpty() ? null : timeOfDayPredicate(newFilters));
        }

        // Updated state
        return {
          ...state,
          todFilters: newFilters,
        };
      },
    todTabSwitcher: ({ todTab, ...state }, fns) => (e) => {
      e.preventDefault();
      return {
        ...state,
        todTab: e.target.text,
      };
    },
  }
)(TimeOfDayFilter);



// WEBPACK FOOTER //
// ./src/ndc/offer/filters/timeOfDay/TimeOfDayFilter.js